import { render, staticRenderFns } from "./float-zixunjianyi-zixun.vue?vue&type=template&id=4fd1675e&"
import script from "./float-zixunjianyi-zixun.vue?vue&type=script&lang=js&"
export * from "./float-zixunjianyi-zixun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports